import { Unit } from './units';

import type { SwingPosition } from './analysis.types';

// Limit the use of zIndex to these.
const ZINDEX = {
    ABOVE1: 1,
    ABOVE2: 2,
    ABOVE3: 3,
    ABOVE4: 4,
    MODAL: 5,
    UNDER1: -1,
    UNDER2: -2,
};

// High speed cameras
// TODO: It's very important that this number is correct so that we know how to play 1x speed videos.
// Seems like this needs to be part of the camera config.
const CAMERA_FPS = 255 as const;
// Playback fps of video files
const VIDEO_FPS = 25 as const;

// 1, 2, 4, and 7 are KEY positions
export const KEY_POSITION_INDICES = [0, 1, 3, 6];

export const SWING_POSITIONS: SwingPosition[] = ['p1', 'p2', 'p3', 'p4', 'p5', 'p6', 'p7', 'p8', 'p9', 'p10'];

export const KEY_SWING_POSITIONS = ['p1', 'p2', 'p4', 'p7'] as const;

export const CAMERA_ANGLES = ['face_on', 'trail_front', 'down_the_line', 'back'] as const;

export const AVAILABLE_PLAYBACK_SPEEDS = [0.25, 0.5, 1] as const;

const SCREEN = {
    SPACING: 20,
    HEADER_HEIGHT: 84,
};

export const constants = {
    ZINDEX,
    CAMERA_FPS,
    VIDEO_FPS,
    KEY_POSITION_INDICES,
    SWING_POSITIONS,
    SCREEN,
};

export type LayoutType = 'public' | 'private';
export const DEFAULT_LAYOUT_NAME = 'Default Layout';

export type Axis = 'x' | 'y' | 'z' | 'w';

export const ALL_AXES: Axis[] = ['x', 'y', 'z', 'w'];

export const DEFAULT_KEY_PARAMETER_ID = 'pelvis_sway_p7';

export type Device = 'kiosk' | 'floor';

export type PanelType =
    | 'swing_foundations'
    | 'module'
    | 'key'
    | 'linear_position'
    | 'angular_position'
    | 'linear_displacement_from_p1'
    | 'angular_displacement_from_p1'
    | 'linear_velocity'
    | 'angular_velocity'
    | 'linear_acceleration'
    | 'angular_acceleration'
    | 'angle'
    | 'distance'
    | 'speed'
    | 'ratio';

export interface TimeSeries {
    readonly id: string;
    readonly unit: Unit;
}
